import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { SharedService } from 'src/app/shared/shared.service';
import { AppConstants } from 'src/app/config.service';
import { finalize } from 'rxjs/operators';
import * as moment from 'moment'
import { ExceptionHandlingService } from 'src/app/shared/exception-handling.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastService, IMyOptions } from 'ng-uikit-pro-standard';


@Component({
  selector: 'download-selections-modal',
  templateUrl: './download-selections-modal.component.html'
})
export class DownloadSelectionsModalComponent implements OnInit {

  @Input() selections: any;
  @Output() emitSuccess = new EventEmitter<any>();
  error: any = {}

  constructor(
    private service: SharedService,
    private appConstants: AppConstants,
    private errorService: ExceptionHandlingService,
    private toastr: ToastService,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    this.error = {}
    this.downloadNotice = {}
  }

  datePickerOptions: IMyOptions = {
    dateFormat: 'mmm-dd-yyyy',
    closeAfterSelect: true,
    editableDateField:false
  };

  action: any = {}
  @ViewChild('downloadNoticeModal', { static: true }) downloadNoticeModal: any;

  downloadNotice: any = {};
  ngOnChanges() {
    if (this.selections && this.selections.selectedSelections && this.selections.selectedSelections.length){
    this.error = {}
    this.downloadNotice = {}
    this.getDownloadData()
    }
  }

  async getDownloadData() {
    this.downloadNotice = {
      noticeType: null
    };
    this.downloadNoticeModal.show();
    await this.getNoticeType();
    this.downloadNotice.noticeType = this.noticeTypes.selectionLetterTag;
    this.downloadNoticeTagChange();
  }

  noticeTypes: any = {};
  noticeTypesLoading: boolean = false;
  getNoticeType() {
    this.noticeTypes = {};
    const url = this.appConstants.endPoints.certificatesEndPoint + 'admin/critical-components/settings';
    this.noticeTypesLoading = true;

    return new Promise((resolve, reject) => {
      this.service.get(url, {})
        .pipe(finalize(() => {
          this.noticeTypesLoading = false;
        }))
        .subscribe(data => {
          if (data) {
            if (data.selectionLetterTag.id)
              this.noticeTypes['selectionLetterTag'] = { id: data.selectionLetterTag.id, name: data.selectionLetterTag.name, index: 1 };
            if (data.reminderLetterTag.id)
              this.noticeTypes['reminderLetterTag'] = { id: data.reminderLetterTag.id, name: data.reminderLetterTag.name, index: 2 };
            if (data.lateNoticeLetterTag.id)
              this.noticeTypes['lateNoticeLetterTag'] = { id: data.lateNoticeLetterTag.id, name: data.lateNoticeLetterTag.name, index: 3 };
          }
          resolve(this.noticeTypes)
        }
          , error => {
            this.errorService.errorHandling(error).then(res => {
              this.error = res;
            });
          })
    });

  }

  downloadNoticeTagChange() {
    this.downloadNotice.filename = this.downloadNotice.noticeType.name + '-' + moment(new Date()).format('YYYY-MM-DD-HH:mm:ss') + '.zip'
  }

  downloadNoticeSubmit() {
    const url = this.appConstants.endPoints.certificatesEndPoint + 'critical-components/applicant-component-selections/batch-operations/download';
    let modelSchema = {};
    this.noticeTypesLoading = true;
    modelSchema["filename"] = this.downloadNotice.filename;
    modelSchema["selectAll"] = this.selections.selectAllOption.isAllSelected;
    const criteria = {};
    if (this.selections.selection.selectionYear) {
      let selectedYear = new Date(this.selections.selection.selectionYear);
      criteria["selectionYear"] = (selectedYear).getFullYear();
    }
    if (this.selections.selection.region)
      criteria["regionId"] = this.selections.selection.region.id

    if (this.selections.selection.customerDisplayName)
      criteria["customerDisplayName"] = this.selections.selection.customerDisplayName

    if (this.selections.selection.name)
      criteria["name"] = this.selections.selection.name

    if (this.selections.selection.status)
      criteria["status"] = this.selections.selection.status
    criteria["pageNumber"] = this.selections.pageInfo.currentPage;
    criteria["pageSize"] = this.selections.pageInfo.itemsPerPage;
    criteria["isPaging"] = true;
    if(this.selections.selectedSelections && this.selections.selectedSelections.length)
    criteria['applicantComponentSelectionIds'] = this.selections.selectedSelections.map(res=> res.id)
    modelSchema["criteria"] = criteria;

    modelSchema["tagId"] = this.noticeTypes.selectionLetterTag.id;
    this.service.postDownload(url, {}, modelSchema, true).pipe(finalize(() => {
      this.downloadNoticeModal.hide();
      this.noticeTypesLoading = false;
    }))
      .subscribe(data => {
        if (data && data.body) {
          const contentDispositionHeader = data.headers.get('content-disposition');
          const header = contentDispositionHeader.split(';')[1].trim().split('=')[1];
          const body = data.body;
          let url = window.URL.createObjectURL(new Blob([body]));
          let a = window.document.createElement('a');
          a.href = url;
          a.download = this.downloadNotice.filename;
          document.body.appendChild(a);
          a.click();
          setTimeout(function () {
            window.URL.revokeObjectURL(url);
          }, 100);
        }
        else
          this.toastr.error(this.translate.instant('administration_noNoticeFound_label'));
      },
        error => {
          this.errorService.errorHandling({ error: error }).then(res => {
            this.error = res;
          });
        })

  }
}